import { globalAxios } from "@/axios-path.js";
//fetchFoodPromotionBack
export default {
  namespaced: true,
  state: {
    promotion_list: [],
    promotion_use_log: [],
    promotion_banner: [],
  },
  mutations: {
    resetState(state) {
      state.promotion_list = [];
      state.promotion_use_log = [];
      state.promotion_banner = [];
    },
    getPromotionList(state, data) {
      state.promotion_list = data;
    },
    getPromotionLog(state, data) {
      state.promotion_use_log = data;
    },
    getPromotionBanner(state, data) {
      state.promotion_banner = data;
    },
    addPromotionBanner(state, data) {
      state.promotion_banner.push(data);
    },
    editPromotionBanner(state, { res_data, index }) {
      for (let val of state.promotion_banner) {
        let index = state.promotion_banner.indexOf(val)
        if (val.banner_promotion_id == res_data.banner_promotion_id) {
          Object.assign(state.promotion_banner[index], res_data);
        }
      }
    },
    deletePromotionBanner(state, form) {
      for (let val of state.promotion_banner) {
        let index = state.promotion_banner.indexOf(val);
        if (val.banner_promotion_id == form.banner_promotion_id) {
          state.promotion_banner.splice(index, 1);
        }
      }
    },
  },
  actions: {
    updatePromotionDetailAllProvince({ }, payload) {
      let url = `/api/v1/update/promotion`;
      return globalAxios
        .put(url, payload)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => []);
    },
    fetchPromotionByIdAllProvince({ commit }, promotion_id) {
      let url = `/api/v1/promotion/detail/${promotion_id}`;
      return globalAxios
        .get(url)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return {};
          return res.data;
        })
        .catch((error) => { });
    },
    fetchPromoListAllProvince({ commit }) {
      let url = "/api/v1/promotion/list";
      return globalAxios
        .get(url)
        .then((res) => {
          console.log(res);
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => []);
    },
    fetchPromoLogAllProvince(
      { commit },
      { promotion_id, page_size, current_page, search }
    ) {
      let url = `/api/v1/promotion/transaction/${promotion_id}`;
      let config = {
        page_size,
        current_page,
        search,
      };

      return globalAxios
        .get(url, { params: config })
        .then((res) => {
          console.log(res);
          if (res.msg === false) return [];
          return res.data;
        })
        .catch((error) => []);
    },
    createPromotionAllProvince({ rootState, dispatch }, payload) {
      let url = `/api/v1/create/promotion`;
      return globalAxios
        .post(url, payload)
        .then((res) => {
          if (res.msg === false) return false;
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    deletePromotionAllProvince({ rootState, dispatch }, promotion_id) {
      let url = `/api/v1/delete/promotion/${promotion_id}`;
      return globalAxios
        .delete(url)
        .then((res) => {
          if (res.msg === false) return false;
          return true;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async sortPromoBanner({ commit, rootState, dispatch }, sort_product_list) {
      let url = rootState.api_urls.Backoffice_sortPromoBanner;
      let form = sort_product_list;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return 2;
      }
    },
    async editPromotionDetail({ rootState, dispatch, commit }, { form, province }) {
      let url =
        `/api/v1/${province}/promotion/BackOfficeUse/details/${form.promotion_id}`
      return globalAxios
        .put(url, form)
        .then((data) => {
          commit("getPromotionList", data);
          return data;
        })
        .catch((error) => []);
    },
    async getPromotionDetail({ rootState, dispatch, commit }, { promotion_id, province }) {
      let url =
        '/api/v1/' + province + '/promotion/BackOfficeUse/details/' + promotion_id;
      return globalAxios
        .get(url)
        .then((data) => {
          return data;
        })
        .catch((error) => { return false; });
    },
    async deletePromotionBanner({ rootState, dispatch, commit }, { form }) {
      let url =
        rootState.api_urls.fetchFoodPromotionBack_deletePromotionBanner +
        form.banner_promotion_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("deletePromotionBanner", form);
      }
    },
    async editPromotionBanner(
      { rootState, dispatch, commit },
      { form, index }
    ) {
      let url =
        rootState.api_urls.fetchFoodPromotionBack_editPromotionBanner +
        form.banner_promotion_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("editPromotionBanner", {
          res_data: res,
          index,
        });
        return true;
      }
    },
    async addPromotionBanner({ rootState, dispatch, commit }, form) {
      let url = rootState.api_urls.fetchFoodPromotionBack_addPromotionBanner;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("addPromotionBanner", res);
        return true;
      }
    },
    async getPromotionBanner({ rootState, dispatch, commit }, promotion_id) {
      let url = rootState.api_urls.fetchFoodPromotionBack_getPromotionBanner;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return err;
      } else {
        commit("getPromotionBanner", res);
        return "No data";
      }
    },
    // Refactored to use globalAxios directly with dynamic province path
    async getPromotionLog({ commit }, { province, promotion_id }) {
      commit("getPromotionLog", []);
      const url = `/api/v1/${province}/promotion/list/transaction/${promotion_id}`;
      return globalAxios
        .get(url)
        .then((data) => {
          commit("getPromotionLog", data);
          return data;
        })
        .catch(() => false);
    },
    async addPromotion({ commit }, { form, province }) {
      const url = `/api/v1/${province}/promotion/create`;
      return globalAxios
        .post(url, form)
        .then((data) => {
          // Backend expected to return updated promotion list (following editPromotionDetail pattern)
          commit("getPromotionList", data);
          return data;
        })
        .catch(() => false);
    },
    async getPromotionList({ rootState, dispatch, commit }, province) {
      let url = '/api/v1/' + province + '/promotion/list'
      return globalAxios
        .get(url)
        .then((data) => {
          commit("getPromotionList", data);
          return data;
        })
        .catch((error) => { return false; });

    },
    async deletePromotionDetail({ commit }, { promotion_id, province }) {
      const url = `/api/v1/${province}/promotion/BackOfficeUse/details/${promotion_id}`;
      return globalAxios
        .delete(url)
        .then((data) => {
          commit("getPromotionList", data);
          return data;
        })
        .catch(() => false);
    },
  },
  getters: {},
};
